<template>
    <div>
        <imask-input
            :disabled="true"
            v-if="field._mask"
            class="input keyboard_input"
            :class="validator.failed ? 'input_error' : ''"
            v-model="local_data"
            @input="$emit('input',local_data)"

            :mask="field._mask._mask"
            :unmask="field._mask._unmask"
            :prepare="field._mask._prepare"
            :validate="field._mask._validate"
            :commit="field._mask._commit"
            :overwrite="field._mask._overwrite"
            :placeholderChar="field._mask._placeholder_char"
            :lazy="field._mask._lazy"
            :definitions="field._mask._definitions"
            :blocks="field._mask._blocks"
            :pattern="field._mask._pattern"
            :format="field._mask._format"
            :parse="field._mask._parse"
            :autofix="field._mask._autofix"
            :radix="field._mask._radix"
            :thousandsSeparator="field._mask._thousands_separator"
            :mapToRadix="field._mask._map_to_radix"
            :scale="field._mask._scale"
            :signed="field._mask._signed"
            :normalizeZeros="field._mask._normalize_zeros"
            :padFractionalZeros="field._mask._pad_fractional_zeros"
            :min="field._mask._min"
            :max="field._mask._max"
            :dispatch="field._mask._dispatch"
        />

        <b-input v-else v-model="local_data" :name="name" :id="name" :custom-class="validator.failed ? 'input_error' : ''" :disabled="true" class="keyboard_input"></b-input>
        <div class="keyboard-container">
            <div class="keyboard-row" v-for="(row,key_row) in keyboard_content" :key="key_row">
                <b-button :disabled="block_form||button==null" v-for="(button,key_button) in row" :key="key_button" @click="clickButton(button)" class="keyboard-button"
                          :class="{'keyboard-button--null':button==null}"
                          type="is-primary" outlined
                          expanded>
                    <b-icon v-if="button == 'del'" icon="backspace"></b-icon>
                    <b-icon v-else-if="button == 'next'" icon="check"></b-icon>
                    <span v-else v-html="button"></span>
                </b-button>
            </div>
        </div>
        <b-button type="button is-primary next-button" :disabled="block_form" @click="nextStep()" v-html="step._button"></b-button>
    </div>
</template>

<script>
import {call, get} from "vuex-pathify";
import {IMaskComponent} from 'vue-imask';

export default {
    components: {'imask-input': IMaskComponent},
    props: ['value', 'field', 'validator', 'name', 'step'],
    computed: {
        loading: get('func_data/loading'),
        block_form: get('func_data/block_form'),
    },
    created() {
        this.local_data = this.value;
    },
    data() {
        return {
            local_data: '',
            keyboard_content: [
                ['1', '2', '3'],
                ['4', '5', '6'],
                ['7', '8', '9'],
                [null, '0', 'del'],
            ]
        }
    },
    watch:{
        local_data:function (newVal, oldVal){
            if(!this.field._mask){
                this.$emit('input', newVal)
            }
        }
    },
    methods: {
        nextStep: call('form/goToNextStep'),
        clickButton(content) {
            let new_value = this.value;
            if (content == 'del') {
                new_value = _.dropRight(new_value).join('');
                this.local_data = new_value;
            }

            if (content == 'next') {
                this.$emit('nextStep');
            }

            if (content != 'next' && content != 'del') {
                if (new_value) {
                    new_value += content;
                } else {
                    new_value = content;
                }
                this.local_data = new_value;
            }
        }
    }
}
</script>

<style lang="scss">

</style>
